// Versioned byte sampling, not a perceptual/video-content hash.
const CHUNK_BYTES = 1024 * 1024
const SAMPLE_COUNT = 5

export function recordingSampleRanges(size) {
  if (!Number.isSafeInteger(size) || size <= 0) throw new Error('The recording is empty.')
  if (size <= CHUNK_BYTES * SAMPLE_COUNT) return [[0, size]]
  return Array.from({ length: SAMPLE_COUNT }, (_, index) => {
    const start = Math.floor((size - CHUNK_BYTES) * index / (SAMPLE_COUNT - 1))
    return [start, start + CHUNK_BYTES]
  })
}

function readSlice(blob, signal) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    const abort = () => reader.abort()
    const cleanup = () => signal.removeEventListener('abort', abort)
    reader.onload = () => { cleanup(); resolve(reader.result) }
    reader.onerror = () => { cleanup(); reject(reader.error) }
    reader.onabort = () => { cleanup(); reject(new Error('Recording check cancelled.')) }
    if (signal.aborted) return reject(new Error('Recording check cancelled.'))
    signal.addEventListener('abort', abort, { once: true })
    reader.readAsArrayBuffer(blob)
  })
}

export async function recordingFingerprint(file, signal) {
  const ranges = recordingSampleRanges(file.size)
  // Bind scheme and size to content, never the filename.
  const header = new TextEncoder().encode(`sample-v1:${file.size}\n`)
  const bytes = new Uint8Array(header.length + ranges.reduce((sum, [a, b]) => sum + b - a, 0))
  bytes.set(header)
  let offset = header.length
  for (const [start, end] of ranges) {
    const chunk = await readSlice(file.slice(start, end), signal)
    bytes.set(new Uint8Array(chunk), offset)
    offset += chunk.byteLength
  }
  if (signal.aborted) throw new Error('Recording check cancelled.')
  const digest = await crypto.subtle.digest('SHA-256', bytes)
  const hex = Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('')
  return `sample-v1:${file.size}:${hex}`
}
